// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kC","header":"kD","title":"kE","subheader":"kF","formWrapper":"kG"};